/**
 * @generated SignedSource<<10a6f4b19e7d45278a838b711cd9a69f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelPrepareConfigurationInput = {
  code: string;
  imageUrl?: string | null;
  isSideImageScalingEnabled: boolean;
  salesChannelID: string;
};
export type connectCatalogMutation$variables = {
  input: ModelPrepareConfigurationInput;
};
export type connectCatalogMutation$data = {
  readonly prepareConfiguration: {
    readonly alreadyConfigured: boolean;
    readonly imageUrl: string | null;
  };
};
export type connectCatalogMutation = {
  response: connectCatalogMutation$data;
  variables: connectCatalogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModelPrepareConfigurationOutput",
    "kind": "LinkedField",
    "name": "prepareConfiguration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alreadyConfigured",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "connectCatalogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "connectCatalogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2b96e88e4c6c4ca1e17dd7787775e36",
    "id": null,
    "metadata": {},
    "name": "connectCatalogMutation",
    "operationKind": "mutation",
    "text": "mutation connectCatalogMutation(\n  $input: ModelPrepareConfigurationInput!\n) {\n  prepareConfiguration(input: $input) {\n    imageUrl\n    alreadyConfigured\n  }\n}\n"
  }
};
})();

(node as any).hash = "f59ad328af347883a2579106a4f7f50f";

export default node;
